import React, { FC, useCallback } from 'react';
import { ModalWrapper } from 'components/modals/ModalWrapper';
import { MenuViewerForDiagnose } from 'pages/PracticePage/components/MenuViewerForDiagnose';

import { MenuType } from 'components/MenuConst/DiagnoseMenu';

export const useMenuWatchModal = (menu: MenuType) => {
  const [open, setOpen] = React.useState(false);

  const toggleModalOpen = () => {
    setOpen(!open);
  };

  const forceModalOpen = useCallback((openOrClose: boolean) => {
    setOpen(openOrClose);
  }, []);

  return {
    forceModalOpen: forceModalOpen,
    toggleModalOpen: toggleModalOpen,
    MenuWatchModal: (
      <MenuWatchModal isModalOpen={open} setIsModalOpen={setOpen} menu={menu} />
    ),
  };
};

type Props = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  menu: MenuType;
};

const MenuWatchModal: FC<Props> = ({ isModalOpen, setIsModalOpen, menu }) => {
  return (
    <ModalWrapper isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
      <div>
        <div style={{ margin: '2px 0 12px 0' }}>
          <MenuViewerForDiagnose playlist={menu} />
        </div>
      </div>
    </ModalWrapper>
  );
};
